<div
  class="h-screen flex flex-col bg-gradient-to-b from-[#095744] via-[#085240] to-[#043b2d] border-r-2 border-[#e6b012] transition-all duration-300 ease-in-out relative z-30 shadow-2xl"
  [ngClass]="{
    'w-72': isOpen,
    'w-20': !isOpen,
  }"
>
  <!-- Header -->
  <div
    class="flex items-center py-3.5 px-4 border-b border-white/10 bg-[#064234] sticky top-0 z-10"
    [ngClass]="{ 'justify-between': isOpen, 'justify-center flex-col gap-2': !isOpen }"
  >
    <div
      class="flex items-center gap-3 cursor-pointer shrink-0"
      [routerLink]="['', 'modules']"
      title="Government MEL System"
    >
      <!-- Coat of Arms Logo Container -->
      <div
        class="relative shrink-0 w-8 h-8 rounded-xl bg-white p-1 flex items-center justify-center cursor-pointer shadow-sm"
      >
        <img src="favicon.ico" alt="Coat of Arms" class="w-full h-full object-contain" />
      </div>

      <!-- Title (Visible when expanded) -->
      @if (isOpen) {
        <div class="overflow-hidden transition-all duration-300">
          <p class="font-extrabold text-white text-xs whitespace-nowrap">
            Government MEL System
          </p>
        </div>
      }
    </div>

    <!-- Toggle Button -->
    <button
      (click)="isOpen = !isOpen"
      class="p-1 rounded-lg text-white/80 hover:text-white hover:bg-white/10 transition-all cursor-pointer focus:outline-none shrink-0"
      title="Toggle Sidebar"
    >
      <mat-icon class="!text-lg !w-4.5 !h-4.5 flex items-center justify-center">density_medium</mat-icon>
    </button>
  </div>

  <!-- Context (optional): the section the menu currently belongs to -->
  @if (context) {
    <div class="border-b border-white/10 px-4 py-3">
      @if (isOpen) {
        <a
          [routerLink]="context.backLink"
          class="inline-flex items-center gap-1 text-[11px] font-semibold text-white/60 transition-colors hover:text-white"
        >
          <mat-icon class="!text-sm !w-4 !h-4 flex items-center justify-center">arrow_back</mat-icon>
          {{ context.backLabel }}
        </a>
        <div class="mt-2.5 flex items-center gap-3">
          @if (context.icon) {
            <div class="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-white/[0.08] text-white ring-1 ring-white/10">
              <mat-icon class="!text-lg !w-5 !h-5 flex items-center justify-center">{{ context.icon }}</mat-icon>
            </div>
          }
          <div class="min-w-0">
            <p class="text-xs font-extrabold leading-snug text-white">{{ context.title }}</p>
            @if (context.subtitle) {
              <p class="truncate text-[11px] text-white/55">{{ context.subtitle }}</p>
            }
          </div>
        </div>
      } @else {
        <a
          [routerLink]="context.backLink"
          [title]="context.backLabel"
          class="flex items-center justify-center rounded-lg p-1.5 text-white/70 transition-colors hover:bg-white/10 hover:text-white"
        >
          <mat-icon class="!text-lg !w-5 !h-5 flex items-center justify-center">arrow_back</mat-icon>
        </a>
      }
    </div>
  }

  <!-- Search Bar -->
  @if (isOpen) {
    <div class="px-4 py-3">
      <div class="relative group">
        <mat-icon
          class="absolute left-3 top-1/2 -translate-y-1/2 text-white/45 group-focus-within:text-white/80 transition-colors !text-sm !w-4 !h-4 flex items-center justify-center"
        >
          search
        </mat-icon>
        <input
          type="text"
          placeholder="Search menu..."
          class="w-full pl-9 pr-4 py-2.5 bg-white/[0.07] rounded-xl text-xs text-white placeholder-white/40 border border-white/10 transition-all
                 hover:bg-white/[0.1] focus:bg-white/[0.12] focus:border-white/20 focus:outline-none"
        />
      </div>
    </div>
  }

  <!-- Navigation Menu -->
  <nav class="flex-1 overflow-y-auto overflow-x-hidden py-2 px-3 space-y-2.5 custom-scrollbar">
    @for (menuItem of menuItems; track $index) {
      @if (!menuItem.data?.['isNotAMenuItem']) {
        <!-- Optional group heading, from data.section -->
        @if (sectionLabel(menuItem, $index); as section) {
          @if (isOpen) {
            <p class="px-3.5 pb-0 pt-2 text-[10px] font-bold uppercase tracking-wider text-white/40">{{ section }}</p>
          } @else {
            <div class="mx-4 border-t border-white/10"></div>
          }
        }
        <div class="relative rounded-2xl overflow-hidden" [class.bg-[#0f4638]]="isOpen && menuItem.children && menuItem.children.length > 0 && isSubmenuExpanded(menuItem)">
          <!-- Top Level Accordion Header -->
          <button
            class="relative flex items-center justify-between w-full text-xs font-extrabold p-3.5 transition-all duration-200 cursor-pointer select-none rounded-xl"
            [ngClass]="isBranchActive(menuItem)
              ? 'bg-white/[0.12] text-white ring-1 ring-white/10 shadow-sm'
              : (isOpen && menuItem.children && menuItem.children.length > 0 && isSubmenuExpanded(menuItem))
                ? 'bg-white/[0.06] text-white'
                : 'text-white/80 hover:bg-white/[0.06] hover:text-white'"
            [attr.aria-current]="isActive(menuItem) ? 'page' : null"
            (click)="handleMenuClick(menuItem)"
          >
            <div class="flex min-w-0 items-center gap-3">
              <mat-icon class="!text-[20px] !w-5 !h-5 shrink-0 flex items-center justify-center">
                {{ menuItem.data?.['icon'] || 'grid_view' }}
              </mat-icon>
              @if (isOpen) {
                <span class="text-left leading-snug tracking-wide">{{ menuItem.data?.['name'] }}</span>
              }
            </div>

            @if (isOpen && menuItem.children && menuItem.children.length > 0) {
              <mat-icon
                class="!text-lg transition-transform duration-300 !w-5 !h-5 flex items-center justify-center"
                [class.rotate-180]="isSubmenuExpanded(menuItem)"
              >
                expand_more
              </mat-icon>
            }
          </button>

          <!-- Collapsed Tooltip Hover Badge -->
          @if (!isOpen) {
            <div
              class="absolute left-full ml-3 px-3 py-1.5 bg-[#064234] text-white text-xs rounded-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 whitespace-nowrap z-50 shadow-xl border border-white/10 font-bold pointer-events-none"
            >
              {{ menuItem.data?.['name'] }}
            </div>
          }

          <!-- Submenu Body (Expanded) -->
          @if (isOpen && menuItem.children && menuItem.children.length > 0 && isSubmenuExpanded(menuItem)) {
            <div class="p-2 space-y-1 bg-[#0f4638] rounded-b-2xl animate-in fade-in duration-200">
              @for (subItem of menuItem.children; track $index) {
                @if (!subItem.data?.['isNotAMenuItem']) {
                  <a
                    [routerLink]="getRoutePath(menuItem, subItem)"
                    [ngClass]="isActive(menuItem, subItem)
                      ? 'bg-white/[0.14] text-white font-semibold ring-1 ring-white/10'
                      : 'text-white/70 hover:text-white hover:bg-white/[0.06]'"
                    [attr.aria-current]="isActive(menuItem, subItem) ? 'page' : null"
                    class="flex items-center justify-between gap-2.5 px-4 py-2.5 rounded-xl text-xs transition-colors cursor-pointer"
                  >
                    <span class="whitespace-nowrap">{{ subItem.data?.['name'] }}</span>
                    @if (isActive(menuItem, subItem)) {
                      <mat-icon class="!text-sm !w-4 !h-4 flex items-center justify-center text-white/70">chevron_right</mat-icon>
                    }
                  </a>
                }
              }
            </div>
          }
        </div>
      }
    }
  </nav>
</div>
